import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  const features = ['+7.000 stickers listos para imprimir', 'Stickers del Mundial 2026', 'Stickers de la Selección Argentina', 'Stickers variados tendencia', 'Alta resolución — calidad profesional', 'Formato PDF y PNG', 'Fondo transparente incluido', 'Descarga inmediata', 'Acceso de por vida'];
  return <section id="pricing" className="py-24 bg-zinc-900" data-id="element-141">
      <div className="container mx-auto px-4" data-id="element-142">
        <div className="text-center mb-16" data-id="element-143">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-144">
            🛒 TU MEGAPACK
          </h2>
          <p className="text-zinc-200 text-[16px]" data-id="element-145">
            Asegurá tu acceso antes de que termine el contador.
          </p>
        </div>

        <div className="max-w-md mx-auto" data-id="element-146">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-black rounded-3xl p-8 shadow-2xl border-2 border-sky-400 flex flex-col h-full relative z-10" data-id="element-147">
            <div className="mb-6" data-id="element-148">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-149">
                🇦🇷 MEGAPACK STICKERS MUNDIAL™
              </h3>
              <p className="text-sky-300 font-bold" data-id="element-150">
                +7.000 Stickers · Descarga Inmediata
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-sky-900/30" data-id="element-151"></div>

            <div className="mb-8" data-id="element-152">
              <div className="flex items-end gap-2" data-id="element-153">
                <span className="text-5xl font-black text-white" data-id="element-154">$19.990</span>
                <span className="text-xl font-bold text-sky-300 mb-1" data-id="element-155">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-156">
              {features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-157">
                  <Check className="w-5 h-5 text-sky-400 shrink-0 mt-0.5" data-id="element-158" />
                  <span className="text-zinc-100" data-id="element-159">{feature}</span>
                </li>)}
            </ul>

            <a href="https://portugueslisto.shop/cart/47736989286594:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-160">
              <Button variant="primary" size="lg" fullWidth withArrow data-id="element-161">
                🔥 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}